import React from "react";

/**
 * Primary logo (full-color, transparent background).
 * Looks clean on ANY background color — use this everywhere by default.
 */
export const LOGO_URL = "/brand/epicom-logo.png";

/**
 * Light variant: dark/graphite pixels are replaced with white,
 * orange accents preserved. Use on orange or photo backgrounds.
 */
export const LOGO_LIGHT_URL = "/brand/epicom-logo-light.png";

/**
 * Epicom Designs sub-brand logo (transparent PNG).
 */
export const DESIGNS_LOGO_URL = "/brand/epicom-designs-logo.png";
/** Cream-theme variant — cobalt + coral instead of orange + grey. */
export const DESIGNS_LOGO_CREAM_URL = "/brand/epicom-designs-logo-cream.png";

export function EpicomLogo({
  className = "h-10 w-auto",
  alt = "Epicom Systems",
  variant = "default",
}) {
  const src = variant === "light" ? LOGO_LIGHT_URL : LOGO_URL;
  return (
    <img
      src={src}
      alt={alt}
      data-testid="epicom-logo"
      className={className}
      loading="eager"
      decoding="async"
    />
  );
}

export function EpicomWordmark({ className = "text-2xl" }) {
  return (
    <span
      className={`heading tracking-tight ${className}`}
      data-testid="epicom-wordmark"
    >
      <span className="text-signal">EPICOM</span>
      <span className="text-white"> SYSTEMS</span>
    </span>
  );
}

/**
 * Epicom Designs sub-brand logo — full-color, transparent background.
 */
export function EpicomDesignsLogo({
  className = "h-10 w-auto",
  alt = "Epicom Designs",
  variant = "default",
}) {
  const src = variant === "cream" ? DESIGNS_LOGO_CREAM_URL : DESIGNS_LOGO_URL;
  return (
    <img
      src={src}
      alt={alt}
      data-testid="epicom-designs-logo"
      className={className}
      loading="eager"
      decoding="async"
    />
  );
}
